import { isEmpty, isDate, isNumericality, isString } from "../utils";
import { ValidatorArgs, ValidatorRuleResult } from ".";

const required = (name: string, values: { [key: string]: any }, args: ValidatorArgs): ValidatorRuleResult => {
    const val = values[name];
    const error = { [name]: args.msg || "Údaj je vyžadován" };

    if (isEmpty(val))
        return error;
};


const date = (name: string, values: { [key: string]: any }, args: ValidatorArgs): ValidatorRuleResult => {
    const val = values[name];
    const error = { [name]: args.msg || "Údaj není platné datum" };

    if (isEmpty(val) || isDate(val))
        return;

    return error;
};



const integer = (name: string, values: { [key: string]: any }, args: ValidatorArgs): ValidatorRuleResult => {
    const val = values[name];
    const error = { [name]: args.msg || "Údaj musí být celé číslo" };

    if (isEmpty(val) || isNumericality(val))
        return;

    return error;
};



/*

const _email = (field, values, args) => {

    const val = values[field];
    const error = { [field]: args.msg || "Údaj není platný email" };

    if (v.isEmpty(val) || v.isEmail(val))
        return;

    return error;
};

const _url = (field, values, args) => {

    const val = values[field];
    const error = { [field]: args.msg || "Údaj není platná URL adresa" };

    if (v.isEmpty(val) || v.isUrl(val))
        return;

    return error;
};


*/


const rules: { [key: string]: any } = {
    required: required,
    integer: integer,
    //email: _email,
    date: date,
    //url: _url
}

export default rules;
